import dateFormat from '@/filters/dateFormat';
import Ax from './axios';
import config from './config';
import app from '../main';

const API = config.BASE_API;

export function findProvince() {
  return Ax.post(`${API}/businessData/findProvince`);
}
export function findCity(provinceGuid) {
  return Ax.post(`${API}/businessData/findCity`, { provinceGuid });
}
export function findHitchJourneyList(data) {
  return Ax.post(`${API}/hitch/getJourneyList`, data);
}
export function findHitchJourneyDetail(journeyId) {
  return Ax.get(`${API}/hitch/getJourneyInfo?journeyGuid=${journeyId}`)
    .then((res) => {
      if (!res.data) {
        app.$notify.error({
          title: '出错了',
          message: '查询不到订单数据',
          duration: 4000
        });
        return {};
      }
      res.data = {
        createTimeName: dateFormat(res.data.createTime),
        aboardTimeName: dateFormat(res.data.aboardTime),
        arriveTimeName: dateFormat(res.data.arriveTime),
        ...res.data,
      };
      return res;
    });
}
export function getDriverList(data) {
  return Ax.post(`${API}/hitch/getDriverList`, data);
}
export function getDriverInfo(newId) {
  return Ax.get(`${API}/hitch/getDriverInfo?newId=${newId}`);
}



// WEBPACK FOOTER //
// ./src/api/hitch.js